//
//  Should be attached to two elements
//  Target - height will be set to this element
//  Source - height will be calculated based on this element and elements with directive-height-offset="TARGET_ID"
//
import { Directive, Input, OnInit, OnDestroy, ElementRef, AfterViewInit, HostBinding, ChangeDetectorRef } from '@angular/core';

import { HeightAdjustService } from './height-adjust.shared.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[directive-height-adjust]',
})
export class HeightAdjustDirective implements OnInit, AfterViewInit, OnDestroy {
    private _init: boolean = false;
    private _mode: string; /* Determine if height should be get 'source' or calculated and set 'target' */
    private _elem: HTMLElement;

    @Input() public targetId: string; /* Use one ID to identify component with height adjustment */
    @Input() public addHeight: number = 0; /* will be added to overall height */

    @HostBinding('style.height') public hostHeight: string = null;

    private _heightUpdateListener$: Subscription;

    constructor(
        private _elementRef: ElementRef,
        private _heightAdjustService: HeightAdjustService,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {

    }

    ngOnInit(): void {
        if (!this.targetId) {
            return console.warn('"targetId" in [directive-height-adjust], and attached to element: ', this._elementRef.nativeElement, ' is not provided');
        }
        const tempMode: string = this._elementRef.nativeElement.getAttribute('directive-height-adjust');
        if (!tempMode || tempMode && (tempMode !== 'target' && tempMode !== 'source')) {
            return console.warn('"mode" in [directive-height-adjust], and attached to element: ', this._elementRef.nativeElement,
                ' is not provided. This directive should have value "source" or "target".');
        }

        this._init = true;
        this._mode = tempMode;
        this._elem = this._elementRef.nativeElement;

        if (this._mode === 'source') {
            this._heightAdjustService.setSource(this.targetId, this._elem);
        } else {
            this._heightAdjustService.setTarget(this.targetId, this._elem);

            this._heightUpdateListener$ = this._heightAdjustService.heightUpdate$
                .subscribe(height => {
                    setTimeout(() => {
                        this.hostHeight = (height + this.addHeight) + 'px';
                        this._changeDetectorRef.detectChanges();
                    }, 0);
                });
        }
    }

    ngAfterViewInit(): void {
        if (!this._init) return;

        setTimeout(() => {
            this._heightAdjustService.recalculateHeight(this.targetId);
        }, 0);
    }

    ngOnDestroy(): void {
        if (!this._init) return;
        this._heightAdjustService.removeEntry(this.targetId);

        if (this._heightUpdateListener$ && !this._heightUpdateListener$.closed) return this._heightUpdateListener$.unsubscribe();
    }
}
